<template >
	<div>
		<h2>Archive</h2>
		<ul class="ArchiveItemList" v-for="year in archiveItems" :key="year.name">
			<TreeItem :ClassNames="ClassNames" :model="year" :class="ClassNames.ItemClass">
				<ArchivePostItem/>
			</TreeItem>
		</ul>
	</div>			
</template>

<script>
import TreeItem from "./TreeItem.vue";
import ArchivePostItem from './ArchivePostItem'

export default {
  name: "Archive",
  props: {
    archiveItems: Array
  },
  data() {
    return {
      ClassNames: {
        ItemClass: "ArchiveItem",
        FolderClass: "ArchiveFolder",
        ItemList: "ArchiveItemList"
      },
    };
  },
  components: {
    TreeItem,ArchivePostItem
  },
  methods: {}
};
</script>

<style lang="postcss">
.ArchiveItem {
	cursor: pointer;
	list-style: none;
}
.ArchiveFolder {
	font-weight: bold;
	font-size: large;
}
.ArchiveItemList {
	padding-left: 1em;
}
</style>
